import { DocumentParticipantsMenu } from '@affine/core/components/collaboration/document-participants-menu';
import { WorkspacePresenceStore } from '@affine/core/modules/organize';
import { useI18n } from '@affine/i18n';
import { CloseIcon } from '@blocksuite/icons/rc';
import { useLiveData, useService } from '@toeverything/infra';
import { useEffect, useMemo } from 'react';

import { PeopleSearchService } from '../services/people-search';
import { QuickSearchService } from '../services/quick-search';
import * as styles from './person-filter.css';
import * as searchUi from './search-ui.css';

export function PersonSearchFilter() {
  const search = useService(QuickSearchService);
  const people = useLiveData(useService(PeopleSearchService).people$);
  const enabled = useLiveData(useService(WorkspacePresenceStore).enabled$);
  const selected = useLiveData(search.personFilter$);
  const names = useMemo(
    () => new Map(people.map(person => [person.id, person.name])),
    [people]
  );
  const ids = useMemo(() => people.map(person => person.id), [people]);
  const t = useI18n();
  useEffect(() => {
    if (!enabled) search.personFilter$.next(null);
  }, [enabled, search]);
  if (!enabled) return null;
  return (
    <div
      className={styles.filters}
      onKeyDown={event => event.stopPropagation()}
    >
      <DocumentParticipantsMenu
        userIds={ids}
        userNames={names}
        triggerLabel={t['com.streamlain.quicksearch.people']()}
        triggerClassName={searchUi.chip}
        onSelectUser={id => {
          const name = names.get(id);
          if (name) search.personFilter$.next({ id, name });
        }}
      />
      {selected ? (
        <button
          type="button"
          className={searchUi.chip}
          data-active="true"
          aria-label={t['com.streamlain.quicksearch.people.clear']({
            name: selected.name,
          })}
          onClick={() => search.personFilter$.next(null)}
        >
          {selected.name}
          <CloseIcon />
        </button>
      ) : null}
    </div>
  );
}
